import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Tab, Nav, Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Style from "../../styles/pages/PoliticaTermos.module.css";
import { FaLock, FaFileContract } from "react-icons/fa";
import Seo from "../../components/layout/Seo.jsx";
import { seo } from "../../data/seoData";
import { getLegalDocuments, getLegalDocumentBySlug } from "../../services/legalService.js";
import LegalContent from "../../components/legal/LegalContent";

const PagePoliticas = ({ standalone = false }) => {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState("privacidade");
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadDocuments = async () => {
      try {
        setLoading(true);
        setError("");
        const response = await getLegalDocuments();
        setDocuments(response?.documents || []);
      } catch (err) {
        console.error("Erro ao carregar documentos legais:", err);
        setError(err.message || "Não foi possível carregar os documentos.");
      } finally {
        setLoading(false);
      }
    };

    loadDocuments();
  }, []);

  const privacyDoc = useMemo(
    () => documents.find((doc) => doc.slug === "privacy_policy"),
    [documents]
  );

  const termsDoc = useMemo(
    () => documents.find((doc) => doc.slug === "terms_of_use"),
    [documents]
  );

  return (
    <>
      <Seo {...seo.politicas} />
      <Tab.Container activeKey={activeKey} style={{ overflow: 'scroll' }} onSelect={(k) => setActiveKey(k)}>
        <Row className={Style.politicaPage} style={{ overflow: 'scroll' }}>
          <Col sm={3} className={Style.sidebar}>
            {standalone && (
              <button
                onClick={() => navigate(-1)}
                className={Style.backButton}
              >
                ← Voltar
              </button>
            )}
            <h5 className={Style.sidebarTitle}>POLÍTICAS</h5>
            <Nav variant="pills" className="flex-column">
              <Nav.Item className={Style.navItem}>
                <Nav.Link eventKey="privacidade" className={Style.navLink}>
                  <FaLock className={Style.icon} /> Privacidade
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className={Style.navItem}>
                <Nav.Link eventKey="termos" className={Style.navLink}>
                  <FaFileContract className={Style.icon} /> Termos de Uso/EULA
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          <Col sm={9} className={Style.content} style={{overflow: 'auto'}}>
            {loading ? (
              <div style={{ padding: "24px", textAlign: "center" }}>
                <Spinner animation="border" />
              </div>
            ) : error ? (
              <Alert variant="danger">{error}</Alert>
            ) : (
              <Tab.Content>
                <Tab.Pane eventKey="privacidade">
                  <h2 className={Style.pageTitle}>PRIVACIDADE</h2>
                  {privacyDoc?.version && (
                    <p className={Style.politicaData}>
                      Última versão: {privacyDoc.version}
                    </p>
                  )}
                  <LegalContent html={privacyDoc?.content_html || ""} />
                </Tab.Pane>

                <Tab.Pane eventKey="termos">
                  <h2 className={Style.pageTitle}>TERMOS DE USO / EULA</h2>
                  {termsDoc?.version && (
                    <p className={Style.politicaData}>
                      Última versão: {termsDoc.version}
                    </p>
                  )}
                  <LegalContent html={termsDoc?.content_html || ""} />
                </Tab.Pane>
              </Tab.Content>
            )}
          </Col>
        </Row>
      </Tab.Container>
    </>
  );
};

export default PagePoliticas;